var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgHorseInFocus(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fillRule: "evenodd"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#634b99",
    d: "M10.356 12.5L19.3 1.582 17.406 0 8.462 10.9l-.484 2.536z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M16.7 5.826V20H3.5V3.386h1.824v-1.83H6.7v1.832h1.366V1.556H9.42v1.832h1.366V1.556h1.366v1.832h1.366V1.556h1.366V2l-2.27 2.764h-.462v.562l-.276.336h-1.1v-.898H9.42v.898H8.056v-.898H6.7v.898H5.324v-.898h-.458v13.858h10.476V7.492L16.7 5.826zM6.37 14.2v3.714h.83V16.36h1.37v1.554h.83V14.2h-.83v1.426H7.2V14.2h-.83zm3.762 0v3.714h.83V14.2h-.83zm2.388 3.714V16.42h1.32v-.682h-1.32v-.85h1.414V14.2H11.7v3.714h.83z",
    fill: "#010101",
    fillRule: "nonzero"
  })));
}
export default SvgHorseInFocus;